module.exports = __webpack_public_path__ + "img/after2.9aa7049e.png";